import React from 'react';

export type FontSizeOption = 'sm' | 'md' | 'lg' | 'xl';

const FONT_SIZE_LABELS: Record<FontSizeOption, string> = {
  sm: 'קטן',
  md: 'בינוני',
  lg: 'גדול',
  xl: 'ענק',
};

interface FontSizeSelectorProps {
  value: FontSizeOption;
  onChange: (value: FontSizeOption) => void;
  label?: string;
}

const FontSizeSelector: React.FC<FontSizeSelectorProps> = ({ value, onChange, label }) => (
  <label className="flex flex-col gap-1 text-right mb-2">
    {label || 'גודל גופן'}
    <select
      className="border rounded px-2 py-1 text-lg"
      value={value}
      onChange={e => onChange(e.target.value as FontSizeOption)}
    >
      {Object.entries(FONT_SIZE_LABELS).map(([key, label]) => (
        <option key={key} value={key}>{label}</option>
      ))}
    </select>
  </label>
);

export default FontSizeSelector; 